/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import { Content_Text } from "../Component/theme";
import ic_right_white from "../image/ic_right_white.png";
import image_home_bottom from "../image/image_home_bottom.png";
import image_main_mid from "../image/live_commerce/image_main_mid.png";
import image_main_mid2 from "../image/live_commerce/image_main_mid2.png";
import image_main_mid3 from "../image/live_commerce/image_main_mid3.png";
import image_process from "../image/live_commerce/image_process.png";
import image_process2 from "../image/live_commerce/image_process2.png";
import image_scroll_down from "../image/image_scroll_down.png";
import image_side_back from "../image/image_side_back.png";
import img_main from "../image/live_commerce/img_main.png";
import img_main_top from "../image/live_commerce/img_main_top.png";
import Logo_ㄱㄱ from "../image/live_commerce/Logo_ㄱㄱ.png";
import Logo_ㄱㄱ2 from "../image/live_commerce/Logo_ㄱㄱ2.png";

import Footer_Live from "./Footer_Live";
import Side_Live from "./Side_Live";
import Header_Live from "./Header_Live";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: ${(props) =>
    props.$scroll > 800 ? "white" : 'rgba("0,0,0,0.5")'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
    background: ${(props) =>
      props.$scroll > 330 ? "white" : 'rgba("0,0,0,0.5")'};
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 15px 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  color: ${(props) => (props.$scroll > 800 ? "#C0C0C0" : "white")};
  transition: color 0.2s ease;
  &:hover {
    color: black;
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
    color: ${(props) => (props.$scroll > 300 ? "#C0C0C0" : "white")};
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const Main_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: white;
  padding-bottom: 200px;
  @media (max-width: 800px) {
    padding-bottom: 30px;
  }
`;
const Main_div3 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  background-color: #fafafa;
`;
const Main_init_div = styled.div`
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 200px;
  flex-direction: row; /* 기본 방향은 행 */

  @media (max-width: 800px) {
    /* flex-direction: column; 모바일 화면에서는 열 방향 */
    padding-top: 50px;
    padding-bottom: 0px;
  }
`;
const Main_init_div2 = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 700px;
  max-width: 1280px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 50px;

  @media (max-width: 800px) {
    height: 250px;
    padding: 0px 15px 50px 15px;
  }
`;

const Main_init_div3 = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 500px;
  max-width: 1280px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 800px) {
    height: 235px;
    padding: 0px 15px;
  }
`;
const Main_init_div4 = styled.div`
  z-index: 2;
  display: flex;
  width: 100%;
  height: 700px;
  max-width: 640px;
  padding: 50px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 800px) {
    height: 350px;
    padding: 15px;
  }
`;

const Main_init_div5 = styled.div`
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 1280px;
  flex-direction: row; /* 기본 방향은 행 */
  padding: 250px 0px;
  @media (max-width: 800px) {
    padding: 100px 0px;
  }
`;

const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 1500px) {
    padding: 0px 60px 20px 60px;
    /* text-align: center; */
  }
  @media (max-width: 800px) {
    padding: 0px 15px 20px 15px;
    /* text-align: center; */
  }
`;

const Main_Content2 = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 1500px) {
    /* text-align: center; */
  }
  @media (max-width: 800px) {
    /* text-align: center; */
  }
`;

const Main_Button = styled.button`
  z-index: 3;
  position: absolute;
  display: flex;
  background-color: ${(props) =>
    props.$black ? "black" : "rgba(255,255,255,0.2)"};
  padding: 11px 22px 11px 32px;
  bottom: 100px;
  border-radius: 100px;
  border-style: solid;
  border-width: 2px;
  border-color: white;
  align-items: center;
  justify-self: center;
  @media (max-width: 800px) {
    padding: 7px 13px 7px 20px;
    bottom: 60px;
    border-width: 1px;
  }
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: black;
    ${Content_Text} {
      transition: color 0.3s ease;
    }
  }
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  margin-top: 80px;
  @media (max-width: 800px) {
    margin-top: 40px;
  }
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Main_Top_IMG = styled(Image)`
  position: absolute;
  width: 100%;
  height: 125%;
  object-fit: cover;
  @media (max-width: 800px) {
    width: 100%;
    height: 135%;
  }
`;

const Info_IMG = styled(Image)`
  width: 600px;
  @media (max-width: 800px) {
    width: 200px;
  }
`;

const Process_IMG = styled(Image)`
  display: flex;
  @media (max-width: 800px) {
    display: none;
  }
`;
const Process_IMG3 = styled(Image)`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const Side_Back = styled(Image)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
`;

const Side_Back2 = styled(Image)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
  @media (max-width: 800px) {
    object-fit: fill;
  }
`;

const Right_Image = styled(Image)`
  height: 30px;
  @media (max-width: 800px) {
    height: 15px;
  }
`;
const Scroll_Down_Image = styled(Image)`
  position: absolute;
  bottom: 15px;
  height: 50px;
  @media (max-width: 800px) {
    height: 25px;
  }
`;

const Bottom_Button = styled.button`
  z-index: 3;
  display: flex;
  background-color: black;
  padding: 11px 22px 11px 32px;
  height: 58px;
  border-radius: 100px;
  align-items: center;
  justify-self: center;
  margin-top: 50px;
  @media (max-width: 800px) {
    padding: 7px 13px 7px 20px;
    height: 40px;
    margin-top: 25px;
  }
  cursor: pointer;
  transition: background-color 0.2s ease;
`;

const Image_Home_Bottom = styled(Image)`
  margin-top: 80px;
  width: 80%;
  justify-self: center;
  margin-bottom: 300px;
  @media (max-width: 800px) {
    width: 90%;
    margin-top: 40px;
    margin-bottom: 100px;
  }
`;
function Home_Live() {
  const navigation = useNavigate();
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const [select, set_Select] = useState("앱");
  const [call, set_Call] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const go_Home = () => {
    navigation("/Live_Commerce");
    window.scrollTo({ top: 0 });
  };
  const go_About = () => {
    navigation("/Live_Commerce/about");
    window.scrollTo({ top: 0 });
  };
  const go_Platform = () => {
    navigation("/Live_Commerce/Platform");
    window.scrollTo({ top: 0 });
  };
  const go_Info = () => {
    navigation("/Live_Commerce/Info");
    window.scrollTo({ top: 0 });
  };
  const go_Process = () => {
    navigation("/Live_Commerce/Process_FMS");
    window.scrollTo({ top: 0 });
  };

  // 사이즈 체크
  useEffect(() => {
    // console.log(event_show);
    // Cookie.remove("event_show");

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const [scrollAmount, setScrollAmount] = useState(0);
  const [logoSrc, setLogoSrc] = useState(Logo_ㄱㄱ2);

  // 스크롤 이벤트 핸들러

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const handleScroll = () => {
    setScrollAmount(window.scrollY);
  };

  useEffect(() => {
    // 화면 크기와 스크롤 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (windowWidth <= 800) {
      setLogoSrc(scrollAmount >= 330 ? Logo_ㄱㄱ2 : Logo_ㄱㄱ);
    } else {
      setLogoSrc(scrollAmount >= 800 ? Logo_ㄱㄱ2 : Logo_ㄱㄱ);
    }
  }, [windowWidth, scrollAmount]);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header $scroll={scrollAmount}>
        <Header_Live logo={logoSrc} />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Main_div>
          <Main_init_div2>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ textAlign: "center" }}
            >
              성공적인 라이브커머스를 구축하는 가장 빠른 방법!
            </Content_Text>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ textAlign: "center" }}
            >
              기역기역 주식회사에서 만들어보세요.
            </Content_Text>
            <Content_Text
              $white
              $large
              style={{ marginTop: 10, textAlign: "center" }}
            >
              기역기역 주식회사의 검증된 전문성과 기술력으로, 신속하고 완벽한
              구축을 약속드립니다.
            </Content_Text>
          </Main_init_div2>
          <Main_Top_IMG src={img_main_top} alt={img_main_top} />
          <Main_Button
            onClick={() => {
              go_About();
            }}
          >
            <Content_Text $white $xlarge>
              문의하기
            </Content_Text>
            <Right_Image src={ic_right_white} alt={ic_right_white} />
          </Main_Button>
          <Scroll_Down_Image src={image_scroll_down} alt={image_scroll_down} />
        </Main_div>

        <Main_div2>
          <Side_Back src={image_side_back} alt={image_side_back} />
          <Main_init_div>
            <Main_Content>
              <Content_Text>
                셀러와 소비자들이 상호작용하는 새로운 소비 트렌드
              </Content_Text>
              <Content_Text $xxlarge $xbold style={{ marginTop: 10 }}>
                라이브커머스
              </Content_Text>
              <Image2
                style={{ width: "80%", justifySelf: "center" }}
                src={img_main}
                alt={img_main}
              />
            </Main_Content>
          </Main_init_div>
        </Main_div2>
        <Main_div3>
          <Main_init_div3>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ textAlign: "center" }}
            >
              라이브로 소통하며 신뢰를 쌓고, 매출을 올려보세요.
            </Content_Text>
            <Content_Text
              $white
              $large
              style={{ marginTop: 5, textAlign: "center" }}
            >
              실시간 반응으로 고객과 더 가까워지고, 더 많은 판매로 비즈니스를
              확장할 수 있습니다.
            </Content_Text>
          </Main_init_div3>
          <Main_Top_IMG src={image_main_mid} alt={image_main_mid} />
        </Main_div3>
        <Main_div2>
          <Side_Back2 src={image_side_back} alt={image_side_back} />
          <Main_init_div>
            <Main_Content>
              <Content_Text $xbold $xxlarge style={{ marginBottom: 4 }}>
                라이브커머스 구축을 기역기역 주식회사에서 하는 이유
              </Content_Text>
              <Content_Text>
                많은 곳에서 기역기역 주식회사를 이용하는데는 이유가 있습니다.
              </Content_Text>
              <Process_IMG
                style={{
                  width: "60%",
                  justifySelf: "center",
                  marginBottom: 60,
                  paddingTop: 150,
                }}
                src={image_process}
                alt={image_process}
              />
              <Process_IMG3
                style={{
                  width: "80%",
                  justifySelf: "center",
                  marginBottom: 60,
                  marginTop: 50,
                }}
                src={image_process2}
                alt={image_process2}
              />
            </Main_Content>
          </Main_init_div>
        </Main_div2>
        <Main_div3>
          <Main_init_div4>
            <Content_Text
              $white
              $xxlarge
              $xbold
              style={{ width: "100%", textAlign: "left" }}
            >
              한 눈에 보는 라이브 관리
            </Content_Text>
            <Content_Text
              $white
              $large
              style={{
                marginTop: 5,
                textAlign: "left",
                width: "100%",
              }}
            >
              실시간으로 진행되는 판매 상황을 한 번에 관리해보세요.
            </Content_Text>
          </Main_init_div4>
          <Main_init_div4>
            <Info_IMG src={image_main_mid3} alt={image_main_mid3} />
          </Main_init_div4>
          <Main_Top_IMG src={image_main_mid2} alt={image_main_mid2} />
        </Main_div3>
        <Main_div3 style={{ marginTop: 0 }}>
          <Side_Back src={image_side_back} alt={image_side_back} />

          <Main_init_div5>
            <Main_Content2>
              <Content_Text $xbold $xxlarge>
                라이브커머스는 단순한 트렌드를 넘어,
              </Content_Text>
              <Content_Text $xbold $xxlarge style={{ marginBottom: 4 }}>
                미래의 필수 판매 전략입니다.
              </Content_Text>
              <Content_Text>
                기역기역 주식회사와 함께 지금 바로 시작해보세요.
              </Content_Text>

              <Bottom_Button
                onClick={() => {
                  go_About();
                }}
              >
                <Content_Text $white $xlarge>
                  문의하기
                </Content_Text>
                <Right_Image src={ic_right_white} alt={ic_right_white} />
              </Bottom_Button>
            </Main_Content2>
          </Main_init_div5>
        </Main_div3>
        <Side_Live />
      </Main>
      <Footer>
        <Footer_Live />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
    </Container>
  );
}

export default Home_Live;
